import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  declarationsIdsForUpdate: string[];
  batchId: string;
}

export const useUpdateBatchStatistics = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationsIdsForUpdate, batchId }: HookProps) => {
      const result = await apiClient.batchesWorkflow.updateStatistics.mutation({ params: { id: batchId }, body: { declarationsIdsForUpdate } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error updating statistics for batch!');
    },
  });
};
